// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
! tailwindcss v3.4.10 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */ /* 3 */
  tab-size: 4; /* 3 */
  font-family: ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden] {
  display: none;
}

*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.bottom-0 {
  bottom: 0px;
}
.bottom-\\[10px\\] {
  bottom: 10px;
}
.left-0 {
  left: 0px;
}
.right-0 {
  right: 0px;
}
.right-\\[10px\\] {
  right: 10px;
}
.top-0 {
  top: 0px;
}
.top-1\\/2 {
  top: 50%;
}
.top-\\[0px\\] {
  top: 0px;
}
.top-\\[100px\\] {
  top: 100px;
}
.top-\\[60px\\] {
  top: 60px;
}
.z-10 {
  z-index: 10;
}
.z-\\[1\\] {
  z-index: 1;
}
.z-\\[3\\] {
  z-index: 3;
}
.z-\\[99999999999\\] {
  z-index: 99999999999;
}
.z-\\[9999999999\\] {
  z-index: 9999999999;
}
.z-\\[999999999\\] {
  z-index: 999999999;
}
.z-\\[9999999\\] {
  z-index: 9999999;
}
.z-\\[9999\\] {
  z-index: 9999;
}
.z-\\[999\\] {
  z-index: 999;
}
.z-\\[99\\] {
  z-index: 99;
}
.m-0 {
  margin: 0px;
}
.m-2 {
  margin: 0.5rem;
}
.m-auto {
  margin: auto;
}
.my-\\[15px\\] {
  margin-top: 15px;
  margin-bottom: 15px;
}
.my-\\[50px\\] {
  margin-top: 50px;
  margin-bottom: 50px;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.mb-\\[10px\\] {
  margin-bottom: 10px;
}
.mb-\\[15px\\] {
  margin-bottom: 15px;
}
.mb-\\[20px\\] {
  margin-bottom: 20px;
}
.mb-\\[25px\\] {
  margin-bottom: 25px;
}
.mb-\\[30px\\] {
  margin-bottom: 30px;
}
.mb-\\[60px\\] {
  margin-bottom: 60px;
}
.mb-\\[90px\\] {
  margin-bottom: 90px;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-4 {
  margin-left: 1rem;
}
.ml-\\[10px\\] {
  margin-left: 10px;
}
.ml-\\[250px\\] {
  margin-left: 250px;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-\\[10px\\] {
  margin-right: 10px;
}
.mr-\\[15px\\] {
  margin-right: 15px;
}
.mr-\\[5px\\] {
  margin-right: 5px;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-\\[100px\\] {
  margin-top: 100px;
}
.mt-\\[10px\\] {
  margin-top: 10px;
}
.mt-\\[15px\\] {
  margin-top: 15px;
}
.mt-\\[20px\\] {
  margin-top: 20px;
}
.mt-\\[25px\\] {
  margin-top: 25px;
}
.mt-\\[30px\\] {
  margin-top: 30px;
}
.mt-\\[31px\\] {
  margin-top: 31px;
}
.mt-\\[35px\\] {
  margin-top: 35px;
}
.mt-\\[50px\\] {
  margin-top: 50px;
}
.mt-\\[5px\\] {
  margin-top: 5px;
}
.mt-\\[7px\\] {
  margin-top: 7px;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-\\[100\\%\\] {
  height: 100%;
}
.h-\\[100px\\] {
  height: 100px;
}
.h-\\[150px\\] {
  height: 150px;
}
.h-\\[200px\\] {
  height: 200px;
}
.h-\\[220px\\] {
  height: 220px;
}
.h-\\[35px\\] {
  height: 35px;
}
.h-\\[50px\\] {
  height: 50px;
}
.h-\\[600px\\] {
  height: 600px;
}
.h-\\[60px\\] {
  height: 60px;
}
.h-\\[70px\\] {
  height: 70px;
}
.h-\\[750px\\] {
  height: 750px;
}
.h-auto {
  height: auto;
}
.h-full {
  height: 100%;
}
.h-screen {
  height: 100vh;
}
.max-h-\\[180px\\] {
  max-height: 180px;
}
.max-h-\\[220px\\] {
  max-height: 220px;
}
.max-h-\\[70vh\\] {
  max-height: 70vh;
}
.min-h-\\[220px\\] {
  min-height: 220px;
}
.min-h-\\[600px\\] {
  min-height: 600px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-\\[10\\%\\] {
  width: 10%;
}
.w-\\[100\\%\\] {
  width: 100%;
}
.w-\\[100\\%h\\] {
  width: 100%h;
}
.w-\\[100px\\] {
  width: 100px;
}
.w-\\[120px\\] {
  width: 120px;
}
.w-\\[135px\\] {
  width: 135px;
}
.w-\\[150px\\] {
  width: 150px;
}
.w-\\[190px\\] {
  width: 190px;
}
.w-\\[200px\\] {
  width: 200px;
}
.w-\\[35px\\] {
  width: 35px;
}
.w-\\[400px\\] {
  width: 400px;
}
.w-\\[50\\%\\] {
  width: 50%;
}
.w-\\[50px\\] {
  width: 50px;
}
.w-\\[60px\\] {
  width: 60px;
}
.w-\\[70px\\] {
  width: 70px;
}
.w-\\[90\\%\\] {
  width: 90%;
}
.w-full {
  width: 100%;
}
.max-w-\\[1800px\\] {
  max-width: 1800px;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.-translate-y-1\\/2 {
  --tw-translate-y: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.list-disc {
  list-style-type: disc;
}
.list-none {
  list-style-type: none;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-row {
  flex-direction: row;
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-nowrap {
  flex-wrap: nowrap;
}
.items-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-\\[10px\\] {
  gap: 10px;
}
.gap-\\[12px\\] {
  gap: 12px;
}
.gap-\\[15px\\] {
  gap: 15px;
}
.gap-\\[20px\\] {
  gap: 20px;
}
.gap-\\[25px\\] {
  gap: 25px;
}
.gap-\\[2px\\] {
  gap: 2px;
}
.gap-\\[30px\\] {
  gap: 30px;
}
.gap-\\[5px\\] {
  gap: 5px;
}
.gap-\\[8px\\] {
  gap: 8px;
}
.gap-x-9 {
  column-gap: 2.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-scroll {
  overflow: scroll;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-\\[10px\\] {
  border-radius: 10px;
}
.rounded-\\[16px\\] {
  border-radius: 16px;
}
.rounded-\\[20px\\] {
  border-radius: 20px;
}
.rounded-\\[25px\\] {
  border-radius: 25px;
}
.rounded-\\[50\\%\\] {
  border-radius: 50%;
}
.rounded-\\[50px\\] {
  border-radius: 50px;
}
.rounded-\\[5px\\] {
  border-radius: 5px;
}
.rounded-\\[8px\\] {
  border-radius: 8px;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-sm {
  border-radius: 0.125rem;
}
.rounded-r-md {
  border-top-right-radius: 0.375rem;
  border-bottom-right-radius: 0.375rem;
}
.border {
  border-width: 1px;
}
.border-\\[1px\\] {
  border-width: 1px;
}
.border-\\[2px\\] {
  border-width: 2px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-b-\\[1px\\] {
  border-bottom-width: 1px;
}
.border-b-\\[2px\\] {
  border-bottom-width: 2px;
}
.border-b-\\[5px\\] {
  border-bottom-width: 5px;
}
.border-l-8 {
  border-left-width: 8px;
}
.border-t-2 {
  border-top-width: 2px;
}
.border-t-\\[1px\\] {
  border-top-width: 1px;
}
.border-black {
  --tw-border-opacity: 1;
  border-color: rgb(0 0 0 / var(--tw-border-opacity));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(229 231 235 / var(--tw-border-opacity));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(209 213 219 / var(--tw-border-opacity));
}
.border-gray-400 {
  --tw-border-opacity: 1;
  border-color: rgb(156 163 175 / var(--tw-border-opacity));
}
.bg-\\[\\#000000e8\\] {
  background-color: #000000e8;
}
.bg-\\[\\#1e40af\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.bg-\\[\\#41414e1a\\] {
  background-color: #41414e1a;
}
.bg-\\[\\#D4A373\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 163 115 / var(--tw-bg-opacity));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity));
}
.bg-blue-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(59 130 246 / var(--tw-bg-opacity));
}
.bg-blue-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(30 64 175 / var(--tw-bg-opacity));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}
.bg-gray-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity));
}
.bg-gray-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(156 163 175 / var(--tw-bg-opacity));
}
.bg-gray-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}
.bg-green-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(34 197 94 / var(--tw-bg-opacity));
}
.bg-red-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 68 68 / var(--tw-bg-opacity));
}
.bg-red-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(220 38 38 / var(--tw-bg-opacity));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}
.bg-opacity-50 {
  --tw-bg-opacity: 0.5;
}
.bg-opacity-75 {
  --tw-bg-opacity: 0.75;
}
.bg-opacity-80 {
  --tw-bg-opacity: 0.8;
}
.object-contain {
  object-fit: contain;
}
.object-cover {
  object-fit: cover;
}
.p-2 {
  padding: 0.5rem;
}
.p-4 {
  padding: 1rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.p-\\[10px\\] {
  padding: 10px;
}
.p-\\[12px\\] {
  padding: 12px;
}
.p-\\[15px\\] {
  padding: 15px;
}
.p-\\[20px\\] {
  padding: 20px;
}
.p-\\[25px\\] {
  padding: 25px;
}
.p-\\[5px\\] {
  padding: 5px;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.px-\\[10px\\] {
  padding-left: 10px;
  padding-right: 10px;
}
.px-\\[20px\\] {
  padding-left: 20px;
  padding-right: 20px;
}
.px-\\[25px\\] {
  padding-left: 25px;
  padding-right: 25px;
}
.px-\\[30px\\] {
  padding-left: 30px;
  padding-right: 30px;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-\\[10px\\] {
  padding-top: 10px;
  padding-bottom: 10px;
}
.py-\\[120px\\] {
  padding-top: 120px;
  padding-bottom: 120px;
}
.py-\\[130px\\] {
  padding-top: 130px;
  padding-bottom: 130px;
}
.py-\\[15px\\] {
  padding-top: 15px;
  padding-bottom: 15px;
}
.py-\\[20px\\] {
  padding-top: 20px;
  padding-bottom: 20px;
}
.py-\\[30px\\] {
  padding-top: 30px;
  padding-bottom: 30px;
}
.py-\\[35px\\] {
  padding-top: 35px;
  padding-bottom: 35px;
}
.py-\\[50px\\] {
  padding-top: 50px;
  padding-bottom: 50px;
}
.py-\\[5px\\] {
  padding-top: 5px;
  padding-bottom: 5px;
}
.py-\\[80px\\] {
  padding-top: 80px;
  padding-bottom: 80px;
}
.pb-4 {
  padding-bottom: 1rem;
}
.pb-\\[10px\\] {
  padding-bottom: 10px;
}
.pb-\\[15px\\] {
  padding-bottom: 15px;
}
.pb-\\[20px\\] {
  padding-bottom: 20px;
}
.pb-\\[25px\\] {
  padding-bottom: 25px;
}
.pb-\\[2px\\] {
  padding-bottom: 2px;
}
.pb-\\[50px\\] {
  padding-bottom: 50px;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-\\[110px\\] {
  padding-top: 110px;
}
.pt-\\[120px\\] {
  padding-top: 120px;
}
.pt-\\[150px\\] {
  padding-top: 150px;
}
.pt-\\[20px\\] {
  padding-top: 20px;
}
.pt-\\[25px\\] {
  padding-top: 25px;
}
.pt-\\[30px\\] {
  padding-top: 30px;
}
.pt-\\[50px\\] {
  padding-top: 50px;
}
.pt-\\[60px\\] {
  padding-top: 60px;
}
.pt-\\[80px\\] {
  padding-top: 80px;
}
.pt-\\[95px\\] {
  padding-top: 95px;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-lato {
  font-family: Lato, sans-serif;
}
.font-poppins {
  font-family: Poppins, sans-serif;
}
.font-roboto {
  font-family: Roboto, sans-serif;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[15px\\] {
  font-size: 15px;
}
.text-\\[16px\\] {
  font-size: 16px;
}
.text-\\[18px\\] {
  font-size: 18px;
}
.text-\\[19px\\] {
  font-size: 19px;
}
.text-\\[20px\\] {
  font-size: 20px;
}
.text-\\[22px\\] {
  font-size: 22px;
}
.text-\\[24px\\] {
  font-size: 24px;
}
.text-\\[25px\\] {
  font-size: 25px;
}
.text-\\[26px\\] {
  font-size: 26px;
}
.text-\\[29px\\] {
  font-size: 29px;
}
.text-\\[30px\\] {
  font-size: 30px;
}
.text-\\[32px\\] {
  font-size: 32px;
}
.text-\\[35px\\] {
  font-size: 35px;
}
.text-\\[40px\\] {
  font-size: 40px;
}
.text-\\[45px\\] {
  font-size: 45px;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.text-\\[\\#0F0F0F\\] {
  --tw-text-opacity: 1;
  color: rgb(15 15 15 / var(--tw-text-opacity));
}
.text-\\[\\#5F5F5F\\] {
  --tw-text-opacity: 1;
  color: rgb(95 95 95 / var(--tw-text-opacity));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}
.text-blue-500 {
  --tw-text-opacity: 1;
  color: rgb(59 130 246 / var(--tw-text-opacity));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(17 24 39 / var(--tw-text-opacity));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(34 197 94 / var(--tw-text-opacity));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-100 {
  opacity: 1;
}
.opacity-70 {
  opacity: 0.7;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.brightness-0 {
  --tw-brightness: brightness(0);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-opacity {
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-shadow {
  transition-property: box-shadow;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-300 {
  transition-duration: 300ms;
}
.duration-500 {
  transition-duration: 500ms;
}
.ease-in-out {
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
}

.navabr_shadow{
    box-shadow: 4px -6px 13px 10px;
}

.logo_filter{
    filter: invert(1);
}

.ReactModal__Overlay.ReactModal__Overlay--after-open {
  z-index: 999 !important;
}

.slick-prev {
    left: -14px !important;
    z-index: 999 !important;
}

.slick-next {
    right: 0 !important;
} 

.blog_box {
    box-shadow: 0px 0px 6px 1px;
}

.chatbox-icon {
    position: fixed;
    bottom: 20px;
    right: 20px;
    background-color: #0051c8;
    color: white;
    border-radius: 50%;
    cursor: pointer;
    z-index: 1000;
  }
  
  .chatbox {
    position: fixed;
    bottom: 80px;
    right: 20px;
    width: 300px;
    background-color: white;
    border: 1px solid #ddd;
    border-radius: 10px;
    box-shadow: 0px 0px 15px rgba(0,0,0,0.1);
    z-index: 1000;
  }
  
  .chatbox-header {
    padding: 10px;
    background-color: #0051c8;
    color: white;
    border-radius: 10px 10px 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .chatbox-body {
    padding: 10px;
    max-height: 300px;
    overflow-y: auto;
  }
  
  .message {
    margin-bottom: 10px;
  }
  
  .message.bot {
    text-align: left;
    color: black;
  }
  
  .message.user {
    text-align: right;
    color: blue;
  }
  
  .chatbox-footer {
    padding: 10px;
    background-color: #f1f1f1;
    border-radius: 0 0 10px 10px;
  }
  
  .chatbox-footer button {
    display: block;
    width: 100%;
    margin-bottom: 5px;
    padding: 10px;
    border: none;
    background-color: #0051c8;
    color: white;
    border-radius: 5px;
    cursor: pointer;
  }
  
  .chatbox-footer button:hover {
    background-color: #033a8a;
  }
  


.overlay {
    background: rgba(0, 0, 0, 0.7);
    position: fixed; 
    top: 80px;
    left: 0;
    right: 0;
    bottom: 0;
    max-height: 100px;
    display: flex;
    align-items: center;
    z-index: 999999999; 
}


.modal {
    border-radius: 8px;
    width: 80%;
    max-width: 1200px; 
    max-height: 90%; 
    overflow: hidden; 
    position: relative; 
}


.video-player {
    width: 100%; 
    height: auto; 
    max-height: 80vh; 
    border-radius: 8px;
}

.close-button {
    position: absolute;
    top: 10px;
    right: 10px;
    background: black; 
    color: #fff;
    border: none;
    border-radius: 50px;
    width: 30px;
    height: 30px;
    cursor: pointer;
    z-index: 1000; 
}


iframe#\\:1\\.container {
  display: none !important;
}

a.VIpgJd-ZVi9od-l4eHX-hSRGPd {
  display: none !important;
}


.goog-te-menu-frame {
  display: none !important;
}
.goog-te-menu2 {
  display: none !important;
}


.message {
  padding: 10px; 
}

.mb-2 {
  margin-bottom: 0.5rem;
}

.modal-overlay {
  display: flex;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 99999999999 !important;
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  justify-content: center;
  max-height: 100vh;
  overflow-y: hidden;
}
.modal-content {
  width: 30%; 
  top: 0;
  background-color: rgba(0, 0, 0, 0.8); /* Background color */
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3); /* Shadow */
  border-radius: 10px; /* Rounded corners */
  overflow: hidden; /* Hide overflow for better appearance */
  z-index: 99999999999  !important; 
}

.topbar {
  position: fixed;
  z-index: 99999999;
  width: 100%;
  top: 0;
  text-align: right;
}

.text-shadow-md {
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);
}

button {
  transition: background-color 0.3s ease;
}
button:hover {
  background-color: #e5b97f; /* Slightly darker shade */
}

/* Loader.css */

.loader-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5); /* Optional: Add a background color */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999; /* Ensure it sits on top of other content */
}

.loader img {
  width: 100px; /* Adjust the size of the loader */
  height: auto;
}

/* App.css */

.loading-placeholder,
.navbar-placeholder,
.footer-placeholder,
.chatbox-placeholder {
  height: 60px; /* Reserve space based on the component's dimensions */
  width: 100%;
  background-color: #f3f3f3;
}

.reserved-navbar {
  height: 80px; /* Match your Navbar height */
}

.reserved-footer {
  height: 200px; /* Match your Footer height */
}

.reserved-chatbox {
  height: 60px; /* Match your Chatbox height */
  position: fixed;
  bottom: 0;
  right: 0;
}



@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}




/* Media Queries for Responsive Design */
@media (max-width: 768px) {
 .modal-content {
    width: 80%; 
  }
}

@media (max-width: 480px) {
  .modal-content {
    width: 90%; /* Adjust modal width for extra small screens */
  }

  .modal-overlay {
    align-items: center;
  }

}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:rounded-lg:hover {
  border-radius: 0.5rem;
}

.hover\\:border-\\[1px\\]:hover {
  border-width: 1px;
}

.hover\\:bg-blue-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(37 99 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-500:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(107 114 128 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-600:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(75 85 99 / var(--tw-bg-opacity));
}

.hover\\:bg-gray-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(55 65 81 / var(--tw-bg-opacity));
}

.hover\\:bg-red-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(185 28 28 / var(--tw-bg-opacity));
}

.hover\\:bg-white:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity));
}

.hover\\:text-black:hover {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.hover\\:text-blue-800:hover {
  --tw-text-opacity: 1;
  color: rgb(30 64 175 / var(--tw-text-opacity));
}

.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(59 130 246 / var(--tw-ring-opacity));
}

.group:hover .group-hover\\:opacity-0 {
  opacity: 0;
}

@media (min-width: 640px) {

  .sm\\:ml-\\[250px\\] {
    margin-left: 250px;
  }

  .sm\\:mt-0 {
    margin-top: 0px;
  }

  .sm\\:block {
    display: block;
  }

  .sm\\:hidden {
    display: none;
  }

  .sm\\:h-\\[200px\\] {
    height: 200px;
  }

  .sm\\:h-\\[800px\\] {
    height: 800px;
  }

  .sm\\:min-h-\\[70vh\\] {
    min-height: 70vh;
  }

  .sm\\:w-\\[200px\\] {
    width: 200px;
  }

  .sm\\:w-\\[203px\\] {
    width: 203px;
  }

  .sm\\:w-\\[250px\\] {
    width: 250px;
  }

  .sm\\:w-\\[40\\%\\] {
    width: 40%;
  }

  .sm\\:w-\\[60\\%\\] {
    width: 60%;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }

  .sm\\:justify-between {
    justify-content: space-between;
  }

  .sm\\:gap-\\[20px\\] {
    gap: 20px;
  }

  .sm\\:border-b-\\[1px\\] {
    border-bottom-width: 1px;
  }

  .sm\\:border-none {
    border-style: none;
  }

  .sm\\:bg-\\[\\#000000b3\\] {
    background-color: #000000b3;
  }

  .sm\\:p-0 {
    padding: 0px;
  }

  .sm\\:p-4 {
    padding: 1rem;
  }

  .sm\\:pt-\\[25px\\] {
    padding-top: 25px;
  }

  .sm\\:text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
  }

  .sm\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .sm\\:text-\\[32px\\] {
    font-size: 32px;
  }

  .sm\\:text-\\[40px\\] {
    font-size: 40px;
  }
}

@media (min-width: 768px) {

  .md\\:top-\\[101px\\] {
    top: 101px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:block {
    display: block;
  }

  .md\\:hidden {
    display: none;
  }

  .md\\:max-h-\\[400px\\] {
    max-height: 400px;
  }

  .md\\:min-h-\\[400px\\] {
    min-height: 400px;
  }

  .md\\:w-\\[100\\%\\] {
    width: 100%;
  }

  .md\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .md\\:w-\\[35\\%\\] {
    width: 35%;
  }

  .md\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .md\\:w-\\[49\\%\\] {
    width: 49%;
  }

  .md\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:flex-col {
    flex-direction: column;
  }

  .md\\:gap-16 {
    gap: 4rem;
  }

  .md\\:gap-\\[25px\\] {
    gap: 25px;
  }

  .md\\:border-none {
    border-style: none;
  }

  .md\\:p-0 {
    padding: 0px;
  }

  .md\\:pt-\\[120px\\] {
    padding-top: 120px;
  }

  .md\\:pt-\\[127px\\] {
    padding-top: 127px;
  }

  .md\\:pt-\\[150px\\] {
    padding-top: 150px;
  }

  .md\\:pt-\\[170px\\] {
    padding-top: 170px;
  }

  .md\\:pt-\\[180px\\] {
    padding-top: 180px;
  }

  .md\\:pt-\\[50px\\] {
    padding-top: 50px;
  }

  .md\\:text-\\[18px\\] {
    font-size: 18px;
  }

  .md\\:text-\\[19px\\] {
    font-size: 19px;
  }

  .md\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .md\\:text-\\[24px\\] {
    font-size: 24px;
  }
}

@media (min-width: 1024px) {

  .lg\\:mt-\\[130px\\] {
    margin-top: 130px;
  }

  .lg\\:mt-\\[80px\\] {
    margin-top: 80px;
  }

  .lg\\:w-\\[20\\%\\] {
    width: 20%;
  }

  .lg\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .lg\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .lg\\:w-\\[50\\%\\] {
    width: 50%;
  }

  .lg\\:max-w-\\[2000px\\] {
    max-width: 2000px;
  }

  .lg\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:grid-cols-6 {
    grid-template-columns: repeat(6, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-stretch {
    align-items: stretch;
  }

  .lg\\:gap-\\[55px\\] {
    gap: 55px;
  }

  .lg\\:py-\\[50px\\] {
    padding-top: 50px;
    padding-bottom: 50px;
  }

  .lg\\:py-\\[80px\\] {
    padding-top: 80px;
    padding-bottom: 80px;
  }

  .lg\\:pt-0 {
    padding-top: 0px;
  }

  .lg\\:pt-\\[180px\\] {
    padding-top: 180px;
  }

  .lg\\:pt-\\[200px\\] {
    padding-top: 200px;
  }

  .lg\\:text-\\[20px\\] {
    font-size: 20px;
  }

  .lg\\:text-\\[25px\\] {
    font-size: 25px;
  }

  .lg\\:text-\\[45px\\] {
    font-size: 45px;
  }
}

@media (min-width: 1280px) {

  .xl\\:w-\\[25\\%\\] {
    width: 25%;
  }

  .xl\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .xl\\:w-\\[45\\%\\] {
    width: 45%;
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .xl\\:text-\\[39px\\] {
    font-size: 39px;
  }

  .xl\\:text-\\[50px\\] {
    font-size: 50px;
  }
}

@media (min-width: 1536px) {

  .\\32xl\\:w-\\[30\\%\\] {
    width: 30%;
  }

  .\\32xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .\\32xl\\:grid-cols-7 {
    grid-template-columns: repeat(7, minmax(0, 1fr));
  }
}


`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc,EAAd,MAAc;EAAd,WAAc,EAAd,MAAc;EAAd,+HAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;AAEd;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,4BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;IACI,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,aAAa;EACf;;EAEA;IACE,eAAe;IACf,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,sBAAsB;IACtB,mBAAmB;IACnB,wCAAwC;IACxC,aAAa;EACf;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,4BAA4B;EAC9B;;EAEA;IACE,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;EAC3B;;;;AAIF;IACI,8BAA8B;IAC9B,eAAe;IACf,SAAS;IACT,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,UAAU;IACV,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;;AAGA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,aAAa;AACjB;;;AAGA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,wBAAwB;AAC1B;AACA;EACE,wBAAwB;AAC1B;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,+BAA+B;EAC/B,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,MAAM;EACN,oCAAoC,EAAE,qBAAqB;EAC3D,2CAA2C,EAAE,WAAW;EACxD,mBAAmB,EAAE,oBAAoB;EACzC,gBAAgB,EAAE,wCAAwC;EAC1D,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,MAAM;EACN,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,sCAAsC;AACxC;AACA;EACE,yBAAyB,EAAE,0BAA0B;AACvD;;AAEA,eAAe;;AAEf;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC,EAAE,qCAAqC;EAC3E,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa,EAAE,2CAA2C;AAC5D;;AAEA;EACE,YAAY,EAAE,kCAAkC;EAChD,YAAY;AACd;;AAEA,YAAY;;AAEZ;;;;EAIE,YAAY,EAAE,sDAAsD;EACpE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,YAAY,EAAE,6BAA6B;AAC7C;;AAEA;EACE,aAAa,EAAE,6BAA6B;AAC9C;;AAEA;EACE,YAAY,EAAE,8BAA8B;EAC5C,eAAe;EACf,SAAS;EACT,QAAQ;AACV;;;;AAIA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;;;;AAKA,wCAAwC;AACxC;CACC;IACG,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU,EAAE,+CAA+C;EAC7D;;EAEA;IACE,mBAAmB;EACrB;;AAEF;;AAnSA;EAAA,kBAsSA;EAtSA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA;AAsSA;;AAtSA;EAAA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,kBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,oBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,oBAsSA;EAtSA;AAsSA;;AAtSA;EAAA,oBAsSA;EAtSA;AAsSA;;AAtSA;EAAA;AAsSA;;AAtSA;EAAA,+EAsSA;EAtSA,mGAsSA;EAtSA;AAsSA;;AAtSA;EAAA,8BAsSA;EAtSA;AAsSA;;AAtSA;EAAA,2GAsSA;EAtSA,yGAsSA;EAtSA;AAsSA;;AAtSA;EAAA,oBAsSA;EAtSA;AAsSA;;AAtSA;EAAA;AAsSA;;AAtSA;;EAAA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA,iBAsSA;IAtSA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;AAAA;;AAtSA;;EAAA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;AAAA;;AAtSA;;EAAA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA,iBAsSA;IAtSA;EAsSA;;EAtSA;IAAA,iBAsSA;IAtSA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;AAAA;;AAtSA;;EAAA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;AAAA;;AAtSA;;EAAA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;;EAtSA;IAAA;EAsSA;AAAA","sourcesContent":["@tailwind base;\r\n@tailwind components;\r\n@tailwind utilities;\r\n\r\n.navabr_shadow{\r\n    box-shadow: 4px -6px 13px 10px;\r\n}\r\n\r\n.logo_filter{\r\n    filter: invert(1);\r\n}\r\n\r\n.ReactModal__Overlay.ReactModal__Overlay--after-open {\r\n  z-index: 999 !important;\r\n}\r\n\r\n.slick-prev {\r\n    left: -14px !important;\r\n    z-index: 999 !important;\r\n}\r\n\r\n.slick-next {\r\n    right: 0 !important;\r\n} \r\n\r\n.blog_box {\r\n    box-shadow: 0px 0px 6px 1px;\r\n}\r\n\r\n.chatbox-icon {\r\n    position: fixed;\r\n    bottom: 20px;\r\n    right: 20px;\r\n    background-color: #0051c8;\r\n    color: white;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .chatbox {\r\n    position: fixed;\r\n    bottom: 80px;\r\n    right: 20px;\r\n    width: 300px;\r\n    background-color: white;\r\n    border: 1px solid #ddd;\r\n    border-radius: 10px;\r\n    box-shadow: 0px 0px 15px rgba(0,0,0,0.1);\r\n    z-index: 1000;\r\n  }\r\n  \r\n  .chatbox-header {\r\n    padding: 10px;\r\n    background-color: #0051c8;\r\n    color: white;\r\n    border-radius: 10px 10px 0 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n  }\r\n  \r\n  .chatbox-body {\r\n    padding: 10px;\r\n    max-height: 300px;\r\n    overflow-y: auto;\r\n  }\r\n  \r\n  .message {\r\n    margin-bottom: 10px;\r\n  }\r\n  \r\n  .message.bot {\r\n    text-align: left;\r\n    color: black;\r\n  }\r\n  \r\n  .message.user {\r\n    text-align: right;\r\n    color: blue;\r\n  }\r\n  \r\n  .chatbox-footer {\r\n    padding: 10px;\r\n    background-color: #f1f1f1;\r\n    border-radius: 0 0 10px 10px;\r\n  }\r\n  \r\n  .chatbox-footer button {\r\n    display: block;\r\n    width: 100%;\r\n    margin-bottom: 5px;\r\n    padding: 10px;\r\n    border: none;\r\n    background-color: #0051c8;\r\n    color: white;\r\n    border-radius: 5px;\r\n    cursor: pointer;\r\n  }\r\n  \r\n  .chatbox-footer button:hover {\r\n    background-color: #033a8a;\r\n  }\r\n  \r\n\r\n\r\n.overlay {\r\n    background: rgba(0, 0, 0, 0.7);\r\n    position: fixed; \r\n    top: 80px;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    max-height: 100px;\r\n    display: flex;\r\n    align-items: center;\r\n    z-index: 999999999; \r\n}\r\n\r\n\r\n.modal {\r\n    border-radius: 8px;\r\n    width: 80%;\r\n    max-width: 1200px; \r\n    max-height: 90%; \r\n    overflow: hidden; \r\n    position: relative; \r\n}\r\n\r\n\r\n.video-player {\r\n    width: 100%; \r\n    height: auto; \r\n    max-height: 80vh; \r\n    border-radius: 8px;\r\n}\r\n\r\n.close-button {\r\n    position: absolute;\r\n    top: 10px;\r\n    right: 10px;\r\n    background: black; \r\n    color: #fff;\r\n    border: none;\r\n    border-radius: 50px;\r\n    width: 30px;\r\n    height: 30px;\r\n    cursor: pointer;\r\n    z-index: 1000; \r\n}\r\n\r\n\r\niframe#\\:1\\.container {\r\n  display: none !important;\r\n}\r\n\r\na.VIpgJd-ZVi9od-l4eHX-hSRGPd {\r\n  display: none !important;\r\n}\r\n\r\n\r\n.goog-te-menu-frame {\r\n  display: none !important;\r\n}\r\n.goog-te-menu2 {\r\n  display: none !important;\r\n}\r\n\r\n\r\n.message {\r\n  padding: 10px; \r\n}\r\n\r\n.mb-2 {\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.modal-overlay {\r\n  display: flex;\r\n  align-items: center;\r\n  background-color: rgba(0, 0, 0, 0.8);\r\n  z-index: 99999999999 !important;\r\n  position: absolute;\r\n  top: 0;\r\n  bottom: 0;\r\n  width: 100%;\r\n  justify-content: center;\r\n  max-height: 100vh;\r\n  overflow-y: hidden;\r\n}\r\n.modal-content {\r\n  width: 30%; \r\n  top: 0;\r\n  background-color: rgba(0, 0, 0, 0.8); /* Background color */\r\n  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.3); /* Shadow */\r\n  border-radius: 10px; /* Rounded corners */\r\n  overflow: hidden; /* Hide overflow for better appearance */\r\n  z-index: 99999999999  !important; \r\n}\r\n\r\n.topbar {\r\n  position: fixed;\r\n  z-index: 99999999;\r\n  width: 100%;\r\n  top: 0;\r\n  text-align: right;\r\n}\r\n\r\n.text-shadow-md {\r\n  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.7);\r\n}\r\n\r\nbutton {\r\n  transition: background-color 0.3s ease;\r\n}\r\nbutton:hover {\r\n  background-color: #e5b97f; /* Slightly darker shade */\r\n}\r\n\r\n/* Loader.css */\r\n\r\n.loader-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  background-color: rgba(0, 0, 0, 0.5); /* Optional: Add a background color */\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 9999; /* Ensure it sits on top of other content */\r\n}\r\n\r\n.loader img {\r\n  width: 100px; /* Adjust the size of the loader */\r\n  height: auto;\r\n}\r\n\r\n/* App.css */\r\n\r\n.loading-placeholder,\r\n.navbar-placeholder,\r\n.footer-placeholder,\r\n.chatbox-placeholder {\r\n  height: 60px; /* Reserve space based on the component's dimensions */\r\n  width: 100%;\r\n  background-color: #f3f3f3;\r\n}\r\n\r\n.reserved-navbar {\r\n  height: 80px; /* Match your Navbar height */\r\n}\r\n\r\n.reserved-footer {\r\n  height: 200px; /* Match your Footer height */\r\n}\r\n\r\n.reserved-chatbox {\r\n  height: 60px; /* Match your Chatbox height */\r\n  position: fixed;\r\n  bottom: 0;\r\n  right: 0;\r\n}\r\n\r\n\r\n\r\n@keyframes spin {\r\n  0% { transform: rotate(0deg); }\r\n  100% { transform: rotate(360deg); }\r\n}\r\n\r\n\r\n\r\n\r\n/* Media Queries for Responsive Design */\r\n@media (max-width: 768px) {\r\n .modal-content {\r\n    width: 80%; \r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .modal-content {\r\n    width: 90%; /* Adjust modal width for extra small screens */\r\n  }\r\n\r\n  .modal-overlay {\r\n    align-items: center;\r\n  }\r\n\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
